import React from 'react';
import {withLocalize} from "react-localize-redux";
import LanguageSelector from '../LanguageSelector';
import {Input} from 'reactstrap';

import './style.css';

class TranslationInput extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: props.languages && props.languages.findIndex((lang) => {
				return lang === props.activeLanguage;
			}),
			values: props.languages.length ? props.languages.map((lang) => {
				return {code: lang.code, value: ''}
			}) : [{value: ''}]
		};
		if (props.value) {
			for (let i = 0; i < props.value.length; i++) {
				for (let j = 0; j < this.state.values.length; j++) {
					if (props.value[i].code === this.state.values[j].code) {
						this.state.values[j] = props.value[i];
					}
				}
			}
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleValueChange = this.handleValueChange.bind(this);
	}
	
	handleChange(index) {
		this.setState({selected: index});
	}
	
	handleValueChange(value) {
		let newState = {
			...this.state,
			values: [
				...this.state.values.slice(0, this.state.selected),
				{value, code: this.props.languages[this.state.selected].code},
				...this.state.values.slice(this.state.selected + 1)
			]
		};
		this.setState(newState);
		this.props.onValueChange && this.props.onValueChange(newState.values);
	}
	
	render() {
		return (
			<div className="com-translationinput">
				{this.props.type === "multi" &&
				<Input type="textarea" disabled={this.props.disabled}
				       style={{
					       fontSize: '13px',
					       width: "100%",
					       resize: "none",
					       height: "160px",
					       borderRadius: "4px"
				       }}
				       onChange={(e) => {
					       this.handleValueChange(e.target.value);
				       }} value={this.state.values[this.state.selected].value}/>
				}
				{this.props.type !== "multi" &&
				<Input disabled={this.props.disabled} className="large-input" onChange={(e) => {
					this.handleValueChange(e.target.value);
				}} value={this.state.values[this.state.selected].value}/>
				}
				<LanguageSelector activeLanguage={this.props.languages[this.state.selected]}
				                  languages={this.props.languages}
				                  onLanguageChange={(lang) => {
					                  this.handleChange(this.props.languages.findIndex((l) => (l === lang)));
				                  }}/>
			</div>
		);
	}
}


export default withLocalize(TranslationInput);


// WEBPACK FOOTER //
// ./src/03-components/TranslationInput/index.js